export default {
  title: 'Gérer le compte',
  buttons: {
    save: 'Enregistrer',
    delete: 'Supprimer',
  },
};
